// extracted by mini-css-extract-plugin
module.exports = {"AccountDetailsForm":"AccountDetailsForm_AccountDetailsForm__1exKB","formTextInfo":"AccountDetailsForm_formTextInfo__1KDWp"};